/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KYCFileType {
    PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
    PROOF_OF_IDENTITY = 'PROOF_OF_IDENTITY',
    INVESTMENT_VEHICLE = 'INVESTMENT_VEHICLE',
    FORM = 'FORM',
    OTHER = 'OTHER',
}
